
class Events {

    addEvent(name, callback) {
        window.addEventListener(name, callback);
    }

    removeEvent(name, callback) {
        window.removeEventListener(name, callback);
    }

    trigger(name, data) {
        let event = new Event(name);
		event.data = data;
		window.dispatchEvent(event);
    }
}

let eventManager = new Events();

export default {
    addEvent: eventManager.addEvent,
    removeEvent: eventManager.removeEvent,
    trigger: eventManager.trigger
}


// WEBPACK FOOTER //
// ./src/modules/base/Events.jsx